// features/block/blockApi.js
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { BASE_URL } from '../auth/authApi';

export const blockApi = createApi({
  reducerPath: 'blockApi',
  baseQuery: fetchBaseQuery({ 
    baseUrl: BASE_URL,
    prepareHeaders: (headers) => {
      const token = localStorage.getItem('accessToken');
      if (token) {
        headers.set('Authorization', `Bearer ${token}`);
      }
      return headers;
    },
  }),
  tagTypes: ['BlockStatus'],
  endpoints: (builder) => ({
    getBlockStatus: builder.query({
      query: ({ page = 1, limit = 10, search = '', block = '' }) => {
        const params = new URLSearchParams();
        params.append('page', page);
        params.append('limit', limit);
        if (search) params.append('search', search);
        if (block !== '') params.append('block', block);
        
        return {
          url: '/auth/users/block-status',
          params: Object.fromEntries(params)
        };
      },
      providesTags: ['BlockStatus'],
      transformResponse: (response) => ({
        users: response.users,
        pagination: {
          totalUsers: response.pagination.totalUsers,
          totalPages: response.pagination.totalPages,
          currentPage: response.pagination.currentPage,
          limit: response.pagination.limit
        }
      })
    }),
    toggleBlockUser: builder.mutation({
      query: ({ userId, block, reason = '' }) => ({
        url: '/auth/block-user',
        method: 'POST',
        body: { userId, block, reason },
      }),
      invalidatesTags: ['BlockStatus'],
    }),
  }),
});

export const { 
  useGetBlockStatusQuery,
  useToggleBlockUserMutation 
} = blockApi;